document.addEventListener("DOMContentLoaded", function() {
    function handler(entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
            }
        });
    }

    let animBoxes = document.querySelectorAll(".JS-loading-el"),
        observer = new IntersectionObserver(handler, {threshold: 0.5});

    animBoxes.forEach(function (box) {
        observer.observe(box);
    });

    let animBoxesTop = document.querySelectorAll(".JS-loading-el-top");

    animBoxesTop.forEach(function (box) {
        box.classList.add("is-visible");
    });

    // Přepínání informací o členech týmu
    let teamItem = document.querySelectorAll('[data-team-item]'),
        teamContent = document.querySelectorAll('[data-team-content]');

    teamItem.forEach(function(el) {
       el.addEventListener('click', function() {
           teamItem.forEach(function(e) {
              e.classList.remove('is-visible');
           });
           teamContent.forEach(function(e) {
               e.classList.remove('is-visible');
           });
           this.classList.add('is-visible');
           document.querySelector('#' + this.dataset.id).classList.add('is-visible');
        });
    });
});